import { render, staticRenderFns } from "./TabNovaSimulacao.vue?vue&type=template&id=3c9dd48b&"
import script from "./TabNovaSimulacao.vue?vue&type=script&lang=js&"
export * from "./TabNovaSimulacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports